import { InfoCircle, SingpassClearMyInfoSvg, SingpassMyInfoSvg } from '../../assets/svg'


interface SingpassMyInfoProps{
  onClick:()=>void;
  hasRetrieve?:boolean | null;
  disabled?:boolean
}

function SingpassMyInfo({disabled=false, hasRetrieve=false,...props}:SingpassMyInfoProps) {

  return (
    <div className='polymer-singpass-myinfo'>
      <div className='polymer-singpass-myinfo-description'>
        <div className='polymer-singpass-myinfo-description-icon'>
          <InfoCircle/>
        </div>
        <div className='polymer-singpass-myinfo-description-wrapper'>
          <div className='polymer-singpass-myinfo-description-title'>
            {!hasRetrieve && <h1>You can auto-fill this form by retrieving your details from MyInfo.</h1>}
            {hasRetrieve &&<h1>Your particulars have been retrieved from MyInfo.</h1>}
          </div>
          <div>
            {!hasRetrieve && <p>For faster form completion, 'Retrieve Myinfo' to auto-fill your personal information.</p>}
            {hasRetrieve && <p>'Clear Myinfo' to remove your pre-filled personal information.</p>}
          </div>
        </div>
      </div>
      <div className='polymer-singpass-myinfo-logo' onClick={()=>{
        props.onClick()
      }}>
        {!hasRetrieve && <SingpassMyInfoSvg/>}
        {hasRetrieve && <SingpassClearMyInfoSvg/>}
      </div>
    </div>
  )
}

export default SingpassMyInfo